import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router)

export default new Router({
    // mode: 'history',
    routes: [{
        path: '/Login',
        component: resolve => require(['@/page/Login.vue'], resolve),
    }, {
        path: '/',
        component: resolve => require(['@/page/index.vue'], resolve),
    },
    {
        path: '/index',
        component: resolve => require(['@/page/index.vue'], resolve),
        redirect: '/mini_app/manage_banner',
        children: [
            //AI伴你游
            //猜你想问
            {
                path: '/AI/questions',
                component: resolve => require(['@/page/AI/questions.vue'], resolve)
            },
            //添加问题
            {
                path: '/AI/add_questions',
                component: resolve => require(['@/page/AI/add_questions.vue'], resolve)
            },

            //云上爱教
            //基地管理
            {
                path: '/cloud/base_manage',
                component: resolve => require(['@/page/cloud/base_manage.vue'], resolve)
            },
            // 添加基地
            {
                path: '/cloud/add_base',
                component: resolve => require(['@/page/cloud/add_base.vue'], resolve)
            },
            // 挑战赛
            {
                path: '/answer/challenge',
                component: resolve => require(['@/page/answer/challenge.vue'], resolve)
            },
            // 添加挑战赛
            {
                path: '/answer/add_challenge',
                component: resolve => require(['@/page/answer/add_challenge.vue'], resolve)
            },
            //题库管理
            {
                path: '/answer/question_bank_manage',
                component: resolve => require(['@/page/answer/question_bank_manage.vue'], resolve)
            },
            //添加题库
            {
                path: '/answer/add_question_bank',
                component: resolve => require(['@/page/answer/add_question_bank.vue'], resolve)
            },
            //徽章管理
            {
                path: '/answer/badge_manage',
                component: resolve => require(['@/page/answer/badge_manage.vue'], resolve)
            },
            //添加徽章
            {
                path: '/answer/add_badge',
                component: resolve => require(['@/page/answer/add_badge.vue'], resolve)
            },
            //参与用户
            {
                path: '/route/route_user',
                component: resolve => require(['@/page/route/route_user.vue'], resolve)
            },
            //参与用户详情
            {
                path: '/route/route_user_detail',
                component: resolve => require(['@/page/route/route_user_detail.vue'], resolve)
            },
            //路线管理
              {
                path: '/route/route_manage',
                component: resolve => require(['@/page/route/route_manage.vue'], resolve)
            },
            //添加路线
            {
                path: '/route/add_route',
                component: resolve => require(['@/page/route/add_route.vue'], resolve)
            },
            //banner管理
            {
                path: '/show/banner_manage',
                component: resolve => require(['@/page/show/banner_manage.vue'], resolve)
            },
            //添加banner
            {
                path: '/show/add_banner',
                component: resolve => require(['@/page/show/add_banner.vue'], resolve)
            },
            //展览管理
            {
                path: '/show/show_manage',
                component: resolve => require(['@/page/show/show_manage.vue'], resolve)
            },
            //添加展览
            {
                path: '/show/add_show',
                component: resolve => require(['@/page/show/add_show.vue'], resolve)
            },
            //资讯-banner管理
            {
                path: '/information/banner_manage',
                component: resolve => require(['@/page/information/banner_manage.vue'], resolve)
            },
            //资讯管理
            {
                path: '/information/information_manage',
                component: resolve => require(['@/page/information/information_manage.vue'], resolve)
            },
            //资讯-添加banner
            {
                path: '/information/add_banner',
                component: resolve => require(['@/page/information/add_banner.vue'], resolve)
            },
            //添加资讯
            {
                path: '/information/add_information',
                component: resolve => require(['@/page/information/add_information.vue'], resolve)
            },
            //文创聚焦-banner管理
            {
                path: '/cultureCreativity/banner_manage',
                component: resolve => require(['@/page/cultureCreativity/banner_manage.vue'], resolve)
            },
            //文创聚焦-添加banner
            {
                path: '/cultureCreativity/add_banner',
                component: resolve => require(['@/page/cultureCreativity/add_banner.vue'], resolve)
            },
            //文创聚焦-文创分类
            {
                path: '/cultureCreativity/classify',
                component: resolve => require(['@/page/cultureCreativity/classify.vue'], resolve)
            },
            //文创聚焦-添加分类
            {
                path: '/cultureCreativity/add_classify',
                component: resolve => require(['@/page/cultureCreativity/add_classify.vue'], resolve)
            },
            //文创聚焦-文创商品
            {
                path: '/cultureCreativity/goods',
                component: resolve => require(['@/page/cultureCreativity/goods.vue'], resolve)
            },
            //文创聚焦-添加商品
            {
                path: '/cultureCreativity/add_goods',
                component: resolve => require(['@/page/cultureCreativity/add_goods.vue'], resolve)
            },
            // 行走的思政课 - 趣游海淀
            {
                path: '/courses/activity_route',
                component: resolve => require(['@/page/courses/activity_route.vue'], resolve)
            },
            // 行走的思政课 - 趣游海淀 - 添加路线
            {
                path: '/courses/add_activity_route',
                component: resolve => require(['@/page/courses/add_activity_route.vue'], resolve)
            },
            // 行走的思政课 - 分类
            {
                path: '/courses/classify',
                component: resolve => require(['@/page/courses/classify.vue'], resolve)
            },
            // 行走的思政课 - 添加分类
            {
                path: '/courses/add_classify',
                component: resolve => require(['@/page/courses/add_classify.vue'], resolve)
            },
            // 行走的思政课 - 课程列表
            {
                path: '/courses/courses',
                component: resolve => require(['@/page/courses/courses.vue'], resolve)
            },
            // 行走的思政课 - 添加课程
            {
                path: '/courses/add_courses',
                component: resolve => require(['@/page/courses/add_courses.vue'], resolve)
            },
            {
                path: '/courses/user_clue',
                component: resolve => require(['@/page/courses/user_clue.vue'], resolve)
            },
            {
                path: '/courses/user_clue_detail',
                component: resolve => require(['@/page/courses/user_clue_detail.vue'], resolve)
            },





            //首页
            {
                path: '/home/add_banner',
                component: resolve => require(['@/page/home/add_banner.vue'], resolve)
            }, // -添加轮播图-轮播图-首页
            {
                path: '/home/home_banner',
                component: resolve => require(['@/page/home/home_banner.vue'], resolve)
            }, // 轮播图 - 首页
            {
                path: '/activity/activity_manage',
                component: resolve => require(['@/page/activity/activity_manage.vue'], resolve)
            }, // 活动列表
            {
                path: '/activity/add_activity',
                component: resolve => require(['@/page/activity/add_activity.vue'], resolve)
            }, // 添加活动
            {
                path: '/activity/activity_manage_detail',
                component: resolve => require(['@/page/activity/activity_manage_detail.vue'], resolve)
            }, // 活动详情
            {
                path: '/activity/enroll',
                component: resolve => require(['@/page/activity/enroll.vue'], resolve)
            }, // 报名用户
            {
                path: '/activity/history_activity',
                component: resolve => require(['@/page/activity/history_activity.vue'], resolve)
            }, // 历史活动列表
            {
                path: '/activity/add_history_activity',
                component: resolve => require(['@/page/activity/add_history_activity.vue'], resolve)
            }, // 添加历史活动
            {
                path: '/commissioner/commissioner',
                component: resolve => require(['@/page/commissioner/commissioner.vue'], resolve)
            }, // 委员管理
            {
                path: '/commissioner/add_commissioner',
                component: resolve => require(['@/page/commissioner/add_commissioner.vue'], resolve)
            }, // 添加委员
            {
                path: '/commissioner/apply_record',
                component: resolve => require(['@/page/commissioner/apply_record.vue'], resolve)
            }, // 委员申请记录
            {
                path: '/commissioner/record_detail',
                component: resolve => require(['@/page/commissioner/record_detail.vue'], resolve)
            }, // 申请记录详情



            // 委员 - 通讯录 - 第X届委员会
            {
                path: '/commissioner/contact_book',
                component: resolve => require(['@/page/commissioner/contact_book.vue'], resolve)
            },
            // 委员 - 通讯录 - 添加
            {
                path: '/commissioner/add_contact_book',
                component: resolve => require(['@/page/commissioner/add_contact_book.vue'], resolve)
            },
            // 委员 - 提案
            {
                path: '/commissioner/proposal_manage',
                component: resolve => require(['@/page/commissioner/proposal_manage.vue'], resolve)
            },
            // 委员 - 提案详情
            {
                path: '/commissioner/proposal_detail',
                component: resolve => require(['@/page/commissioner/proposal_detail.vue'], resolve)
            },
            // 委员 - 线下签到列表
            {
                path: '/commissioner/underline_sign',
                component: resolve => require(['@/page/commissioner/underline_sign.vue'], resolve)
            },
            // 委员 - 留言管理
            {
                path: '/commissioner/leave_message_manage',
                component: resolve => require(['@/page/commissioner/leave_message_manage.vue'], resolve)
            },
            // 委员 - 批量导入
            {
                path: '/commissioner/batch_import_user',
                component: resolve => require(['@/page/commissioner/batch_import_user.vue'], resolve)
            },


            {
                path: '/home/welfare',
                component: resolve => require(['@/page/home/welfare.vue'], resolve)
            }, // 福利管理- 首页
            {
                path: '/home/add_welfare',
                component: resolve => require(['@/page/home/add_welfare.vue'], resolve)
            }, // 添加福利-福利管理- 首页
            {
                path: '/home/welfare_v',
                component: resolve => require(['@/page/home/welfare_v.vue'], resolve)
            }, // 福利券管理-福利管理- 首页
            {
                path: '/home/onload_welfare',
                component: resolve => require(['@/page/home/onload_welfare.vue'], resolve)
            }, // 导入福利-福利券管理-福利管理- 首页
            {
                path: '/home/get_power',
                component: resolve => require(['@/page/home/get_power.vue'], resolve)
            }, // 领取权限-福利管理- 首页
            {
                path: '/home/video',
                component: resolve => require(['@/page/home/video.vue'], resolve)
            }, // 视频管理- 首页
            {
                path: '/home/add_video',
                component: resolve => require(['@/page/home/add_video.vue'], resolve)
            }, // 视频管理- 首页
            //用户
            {
                path: '/user/user',
                component: resolve => require(['@/page/user/user.vue'], resolve)
            },
            //添加用户
            {
                path: '/user/add_user',
                component: resolve => require(['@/page/user/add_user.vue'], resolve)
            },  // 用户列表-用户
            {
                path: '/user/import_user',
                component: resolve => require(['@/page/user/import_user.vue'], resolve)
            }, // 用户列表-批量导入用户
            {
                path: '/user/user_detail',
                component: resolve => require(['@/page/user/user_detail.vue'], resolve)
            }, // 查看详情-用户列表-用户
            {
                path: '/user/get_record',
                component: resolve => require(['@/page/user/get_record.vue'], resolve)
            }, // 查看详情-用户列表-用户
            //系统
            {
                path: '/set_up/role_list',
                component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
            }, // 系统角色 - 系统
            {
                path: '/set_up/add_role',
                component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
            }, // 添加角色-系统角色 - 系统
            {
                path: '/set_up/menu_list',
                component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
            }, // 系统菜单 - 系统
            {
                path: '/set_up/add_menu',
                component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
            {
                path: '/set_up/user_list',
                component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
            {
                path: '/set_up/addStaff',
                component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
            }, // 添加菜单-系统菜单 - 系统
            {
                path: '/home/home_background',
                component: resolve => require(['@/page/home/home_background.vue'], resolve)
            }, // 背景图-理论学习-学习新思想-学习新思想背景图修改
            {
                path: '/home/home_content',
                component: resolve => require(['@/page/home/home_content.vue'], resolve)
            }, //内容修改-理论学习-学习新思想-习语近人管理
            {
                path: '/home/add_content',
                component: resolve => require(['@/page/home/add_content.vue'], resolve)
            }, //内容添加-理论学习-学习新思想-习语近人管理
            {
                path: '/set_up/recommend_list',
                component: resolve => require(['@/page/set_up/recommend_list.vue'], resolve)
            }, //推荐管理
            {
                path: '/set_up/add_recommend',
                component: resolve => require(['@/page/set_up/add_recommend.vue'], resolve)
            }, //推荐管理添加
            {
                path: '/home/home_manage',
                component: resolve => require(['@/page/home/home_manage.vue'], resolve)
            }, //实体书店政策及申报管理
            {
                path: '/home/home_dynamic',
                component: resolve => require(['@/page/home/home_dynamic.vue'], resolve)
            },//冬奥动态管理
            {
                path: '/home/add_dynamic',
                component: resolve => require(['@/page/home/add_dynamic.vue'], resolve)
            },//冬奥动态管理添加
            {
                path: '/home/home_comment',
                component: resolve => require(['@/page/home/home_comment.vue'], resolve)
            },//评论管理
            {
                path: '/set_up/set_search',
                component: resolve => require(['@/page/set_up/set_search.vue'], resolve)
            },//搜索关键词设置



            // PS：原来风采管理：/home/home_content?id=2&menu_id=146
            {
                path: '/home/new_style_show',
                component: resolve => require(['@/page/home/new_style_show.vue'], resolve)
            },  // 新版风采管理
            {
                path: '/home/new_add_style',
                component: resolve => require(['@/page/home/new_add_style.vue'], resolve)
            },  // 新版风采管理 - 添加内容


            // 用户协议
            {
                path: '/agreement/user_agreement',
                component: resolve => require(['@/page/agreement/user_agreement.vue'], resolve)
            },
            // 隐私协议
            {
                path: '/agreement/privacy_agreement',
                component: resolve => require(['@/page/agreement/privacy_agreement.vue'], resolve)
            },
        ]
    },
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js